/* __next_internal_client_entry_do_not_use__ cssFromVariantTheme,buttonChildrenColorFromVariantTheme,ButtonStyles auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { buildResponsiveCss } from "@faire/web--source/slate/Theme/ResponsiveCss";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import { cssFromObject } from "@faire/web--source/ui/lib/styleUtils";
import { css } from "styled-components";
import { buttonTheme } from "./theme";
export var cssFromVariantTheme = function(variantTheme, stateKey, buttonProps) {
    var variantStateTheme = variantTheme[stateKey];
    var evaluatedCssObject = typeof variantStateTheme === "function" ? variantStateTheme(buttonProps) : variantStateTheme;
    return cssFromObject(evaluatedCssObject);
};
export var buttonChildrenColorFromVariantTheme = function(variantTheme, stateKey, buttonProps) {
    var variantStateTheme = variantTheme[stateKey];
    var evaluatedCssObject = typeof variantStateTheme === "function" ? variantStateTheme(buttonProps) : variantStateTheme;
    return evaluatedCssObject === null || evaluatedCssObject === void 0 ? void 0 : evaluatedCssObject.color;
};
var makeOverriddenColorTheme = function(theme, color, buttonProps) {
    var overridePart = function(themePart) {
        var evaluatedTheme = typeof themePart === "function" ? themePart(buttonProps) : themePart;
        return _object_spread_props(_object_spread({}, evaluatedTheme), {
            color: color,
            "text-decoration-color": color
        });
    };
    return _object_spread_props(_object_spread({}, theme), {
        base: overridePart(theme.base),
        hover: _object_spread_props(_object_spread({}, overridePart(theme.hover)), {
            filter: "brightness(0.8)"
        }),
        disabled: _object_spread_props(_object_spread({}, overridePart(theme.disabled)), {
            filter: "brightness(0.65)"
        })
    });
};
export var ButtonStyles = function(buttonProps) {
    var _buttonProps_$variant = buttonProps.$variant, $variant = _buttonProps_$variant === void 0 ? "primary" : _buttonProps_$variant, styledComponentsTheme = buttonProps.theme, $tertiaryColor = buttonProps.$tertiaryColor, $loading = buttonProps.$loading, $destructive = buttonProps.$destructive, disabled = buttonProps.disabled, $width = buttonProps.$width, $minWidth = buttonProps.$minWidth;
    var _styledComponentsTheme_buttons2;
    var theme = (_styledComponentsTheme_buttons2 = styledComponentsTheme === null || styledComponentsTheme === void 0 ? void 0 : styledComponentsTheme.buttons2) !== null && _styledComponentsTheme_buttons2 !== void 0 ? _styledComponentsTheme_buttons2 : buttonTheme;
    var variantTheme = theme[$variant];
    var overriddenTheme = $tertiaryColor !== undefined && $variant === "tertiary" ? makeOverriddenColorTheme(variantTheme, $tertiaryColor, buttonProps) : variantTheme;
    return css([
        "",
        ";display:flex;align-items:center;justify-content:center;",
        ";",
        ";cursor:pointer;position:relative;",
        " p,svg{color:",
        ";}&:hover{",
        " p,svg{color:",
        ";}}&:focus-visible{outline:auto;outline:2px solid -webkit-focus-ring-color;outline-offset:2px;}&:active{",
        " p,svg{color:",
        ";}}&:focus:not(:active):not(:hover){",
        " p,svg{color:",
        ";}}&:disabled,&[disabled]{",
        " cursor:default;p,svg{color:",
        ";}}"
    ], function(param) {
        var theme = param.theme;
        return TypographyStyles({
            theme: theme
        });
    }, buildResponsiveCss("width", $width !== null && $width !== void 0 ? $width : "auto"), buildResponsiveCss("min-width", $minWidth !== null && $minWidth !== void 0 ? $minWidth : "initial"), cssFromVariantTheme(overriddenTheme, "base", buttonProps), buttonChildrenColorFromVariantTheme(overriddenTheme, "base", buttonProps), cssFromVariantTheme(overriddenTheme, "hover", buttonProps), buttonChildrenColorFromVariantTheme(overriddenTheme, "hover", buttonProps), cssFromVariantTheme(overriddenTheme, "active", buttonProps), buttonChildrenColorFromVariantTheme(overriddenTheme, "active", buttonProps), cssFromVariantTheme(overriddenTheme, "focus", buttonProps), buttonChildrenColorFromVariantTheme(overriddenTheme, "focus", buttonProps), $loading && ($destructive || disabled) ? cssFromVariantTheme(overriddenTheme, "loading", buttonProps) : cssFromVariantTheme(overriddenTheme, "disabled", buttonProps), $loading && ($destructive || disabled) ? buttonChildrenColorFromVariantTheme(overriddenTheme, "loading", buttonProps) : buttonChildrenColorFromVariantTheme(overriddenTheme, "disabled", buttonProps));
};
